import BaseModal from "./BaseModal";
import makeStyles from '@mui/styles/makeStyles';
import React,{useState} from "react";
import TextInput,{TextInputContainer} from "../forms/TextInput";
import Grid from "@mui/material/Grid";
import {FormControlLabel,Radio,RadioGroup} from "@mui/material";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    radioLabel: {
        color: theme.palette.primary.contrastText
    },
    radioButton: {
        color: theme.palette.primary.contrastText
    },
}));

const organizationType = {
    PA: "0",
    COMPANY: "1"
}

export default function OrganizationModal({open, onClose, onSubmit}){

    const {t} = useTranslation();
    let [title, setTitle] = useState("");
    let [titleError, setTitleError] = useState(false);
    let [type, setType] = useState(organizationType.PA);
    let classes = useStyles();

    const save = () => {
        if(title === "") {
            setTitleError(true)
            return
        }
        onSubmit({title, type})
        close()
    }

    const close = () => {
        setTitle("")
        setType(organizationType.PA)
        setTitleError(false)
        onClose()
    }

    return (
        <BaseModal open={open} onClose={close} onSave={save}>
            <Grid container spacing={4} style={{margin: 0, width: "100%", marginBottom: "1rem"}}>

                    <TextInputContainer xs={12} required label={t('title')} value={title}
                               onTextChange={(value) => {
                                    setTitle(value);
                                    setTitleError(false);
                                }}
                               error={titleError}/>

                <Grid item xs={12} style={{padding: "16px"}}>
                    <RadioGroup value={type} onChange={(event) => setType(event.target.value)} className={classes.radioLabel}>
                        <FormControlLabel value={organizationType.PA} control={<Radio sx={{color : "primary.light", '&.Mui-checked' : {color : "secondary.main"}}}/>} label={t('publicAdministration')} />
                        <FormControlLabel value={organizationType.COMPANY} control={<Radio sx={{color : "primary.light", '&.Mui-checked' : {color : "secondary.main"}}}/>} label={t('company')} />
                    </RadioGroup>
                </Grid>
            </Grid>
        </BaseModal>
    );
}